/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';
import type Router from '@ember/routing/router-service';

class AutomationFinAIAgentContentReadinessRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: Router;

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.content-readiness',
  };

  get titleToken() {
    return this.intl.t('ai-agent.content-readiness.title');
  }

  beforeModel() {
    if (!this.appService.app.canUseFeature('team-kf-content-readiness-scoring-ui')) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.content');
    }
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentContentReadinessRoute, {
  overrideRenderTemplate: false,
});
